import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";

import { login, signUpSuccess } from "../../redux/actions/auth";

import ModalComponent from "../../components/Modal";
import Swal from "sweetalert2";

import { Link, useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";

// import SelectLabels from "../../components/SelectLabels";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import authReducer from "../../redux/reducers";
import { toast, ToastContainer } from "react-toastify";
import LoginLoader from "../../components/LoginLoader";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  IconButton,
  InputAdornment,
  ThemeProvider,
  createTheme,
  Backdrop,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import Recaptcha from "react-recaptcha";
import Loader from "../../components/Loader";
const customId1 = "custom-id-yess";

function Signer(props) {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = React.useState(0);
  const [verified, setVerified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const [statusMann, setStatusMann] = useState();

  const theme = createTheme({
    components: {
      MuiFormLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const recaptchaReloaded = (value) => {
    if (value == "") {
      setVerified(false);
    } else {
      setVerified(true);
    }
  };
  // const phoneRegExp =
  //   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  // state = initialState;

  const statusMan = useSelector((state) => state.authReducer.Signinstatus);

  // console.log(statusMan, statusMan == true);

  useEffect(() => {
    if (statusMan == true) {
      setTimeout(async () => {
        await history.push("/");
      }, 5000);
    }
  }, [statusMan]);
  // useEffect(() => {
  //   if (window.location.href == "http://localhost:3000/SignUp") {
  //   }
  // }, [statusMan]);
  // useEffect(() => {
  //   if (statusMan == false) {
  //     history.push("/verification");
  //   }
  // }, [statusMan]);

  // console.log(window.location.href, "windowe");

  const validationSchema = yup.object({
    username: yup
      .string("Enter Your Username")
      .min(3, "Username should be at least 3 characters long")
      .required("*Username is required")
      .matches(/^(\S+$)/g, "* This field cannot contain  blankspaces"),
    password: yup
      .string()
      .required("Please Enter your  password")
      .min(8)
      .max(12)
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
        "Must Contain at least 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      ),
    name: yup
      .string("Enter your Name")
      .min(2, "Name should be of minimum 2 characters length")
      .required("Name is required"),
    email: yup
      .string()
      .email("E-Mail must be valid")
      .max(255)
      .required("E-Mail  is required"),
    phoneNumber: yup
      .number("Enter  Phone Number ")
      .min(
        1000000000,
        "Phone Number  should be of minimum 10 characters length"
      )
      .max(
        10000000000,
        "Phone Number  should be of maximum 11 characters length"
      )
      .required("Phone is required"),
  });

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      name: "",
      email: "",
      phoneNumber: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        // console.log(values.password);
        // console.log(values.password);
        // console.log(value);

        props.signUpSuccess(
          values.username,
          values.password,
          values.name,
          values.email,
          values.phoneNumber
        );
      } catch (error) {
        // console.log(error);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    },
  });

  return (
    <>
      <div className="container position-sticky z-index-sticky top-0">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
      </div>
      <ToastContainer autoClose={5000} />
      <ThemeProvider theme={theme}>
        <main className="main-content  mt-0">
          <div className=" page-header align-items-start min-vh-100">
            <span className="mask bg-gradient-dark opacity-6"></span>
            <div className="container my-auto">
              <div className="row">
                <div className="col-lg-4 col-md-8 col-12 mx-auto">
                  <div className="card z-index-0 fadeIn3 fadeInBottom card_1">
                    <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                      <div className="bg-gradient-primary shadow-primary border-radius-lg py-3 pe-1">
                        <h4 className="text-white font-weight-bolder text-center mt-2 mb-0">
                          Sign Up
                        </h4>
                      </div>
                    </div>
                    <div className="card-body">
                      <form
                        className="text-start"
                        onSubmit={formik.handleSubmit}
                      >
                        <div className="input-group input-group-outline mb-4">
                          <TextField
                            required
                            className="w-100"
                            label="Username"
                            name="username"
                            variant="outlined"
                            size="small"
                            // type="email"
                            autoFocus
                            value={formik.values.username}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.username &&
                              Boolean(formik.errors.username)
                            }
                            helperText={
                              formik.touched.username && formik.errors.username
                            }
                          />
                        </div>
                        <div className="input-group  input-group-outline mb-4">
                          <TextField
                            required
                            className="w-100"
                            label="Password"
                            name="password"
                            type={showPassword ? "text" : "password"}
                            variant="outlined"
                            size="small"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.password &&
                              Boolean(formik.errors.password)
                            }
                            helperText={
                              formik.touched.password && formik.errors.password
                            }
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                  >
                                    {showPassword ? (
                                      <VisibilityIcon
                                        sx={{ color: "#85CBF2" }}
                                      />
                                    ) : (
                                      <VisibilityOffIcon
                                        sx={{ color: "#85CBF2" }}
                                      />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>

                        <div className="input-group input-group-outline mb-4">
                          <TextField
                            required
                            className="w-100"
                            label="Name"
                            name="name"
                            variant="outlined"
                            size="small"
                            autoFocus
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.name && Boolean(formik.errors.name)
                            }
                            helperText={
                              formik.touched.name && formik.errors.name
                            }
                          />
                        </div>
                        <div className="input-group input-group-outline mb-4">
                          <TextField
                            required
                            className="w-100"
                            label="E-mail"
                            name="email"
                            variant="outlined"
                            type="email"
                            size="small"
                            autoFocus
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.email &&
                              Boolean(formik.errors.email)
                            }
                            helperText={
                              formik.touched.email && formik.errors.email
                            }
                          />
                        </div>
                        <div className="input-group input-group-outline mb-4">
                          <TextField
                            required
                            className="w-100"
                            label="Phone Number"
                            name="phoneNumber"
                            variant="outlined"
                            size="small"
                            type="number"
                            autoFocus
                            value={formik.values.phoneNumber}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.phoneNumber &&
                              Boolean(formik.errors.phoneNumber)
                            }
                            helperText={
                              formik.touched.phoneNumber &&
                              formik.errors.phoneNumber
                            }
                          />
                        </div>

                        <div className="text-center">
                          <button
                            className="btn bg-gradient-primary w-100 my-4 mb-2"
                            type="submit"
                          >
                            Sign Up
                          </button>
                        </div>

                        <p className="mt-4 text-sm text-end">
                          <button
                            type="reset"
                            onClick={formik.resetForm}
                            value="reset"
                            className="text-primary text-gradient font-weight-bold"
                            style={{ border: "none" }}
                          >
                            Reset
                          </button>
                        </p>
                        <Link to="/">
                          <p className="mt-4 text-sm text-end">
                            <button
                              type="reset"
                              value="reset"
                              className="text-primary text-gradient font-weight-bold"
                              style={{ border: "none" }}
                            >
                              Already Have an Account !! Log in
                            </button>
                          </p>
                        </Link>
                      </form>
                      <LoginLoader visible={props.loading} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </ThemeProvider>
    </>
  );
}

const mapStateToProps = (state) => ({
  loading: state.authReducer.loading,
});

const mapDispatchToProps = (dispatch) => ({
  signUpSuccess: (username, password, name, email, phoneNumber) =>
    dispatch(signUpSuccess(username, password, name, email, phoneNumber)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Signer);
